import React, { useEffect, createElement } from 'react';
import { Star } from 'lucide-react';
export function MCBedanktPage() {
  useEffect(() => {
    // Load Typeform script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  // Fire Meta Pixel conversion events (with retry if fbq not ready yet)
  useEffect(() => {
    const fireEvents = () => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'Lead');
        (window as any).fbq('track', 'Masterclass Signup');
        return true;
      }
      return false;
    };
    if (!fireEvents()) {
      // Retry every 500ms for up to 5 seconds
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (fireEvents() || attempts >= 10) {
          clearInterval(interval);
        }
      }, 500);
      return () => clearInterval(interval);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-[#142d52]" data-id="element-2276">
      {/* Hero Section */}
      <section className="py-12 px-4 flex flex-col items-center text-center" data-id="element-2277">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 max-w-3xl" data-id="element-2278">
          Yes! Je hebt een plekje bemachtigd voor de Masterclass!
        </h1>

        <div className="w-full max-w-3xl mb-6" data-id="element-2279">
          <div style={{
          padding: '56.25% 0 0 0',
          position: 'relative'
        }} data-id="element-2280">
            <iframe src="https://player.vimeo.com/video/727758719?h=e9202f5a5e&title=0&byline=0&portrait=0" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Bedankt video" data-id="element-2281"></iframe>
          </div>
        </div>

        <p className="text-sm text-gray-600 italic" data-id="element-2282">
          Lees dan hieronder even verder om te zien hoe je het meeste uit deze
          Masterclass haalt...
        </p>
      </section>

      {/* Dark Banner */}
      <section className="bg-[#333333] py-6 px-4 text-center" data-id="element-2283">
        <h2 className="text-white text-xl md:text-2xl font-bold" data-id="element-2284">
          Zo mis je niets en ben je goed voorbereid:
        </h2>
      </section>

      {/* Steps Section with Background Image */}
      <section className="relative py-16 px-4 bg-cover bg-center bg-fixed" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/5cB7x4JBKLA2SGnQ1mna3u/Scherm%C2%ADafbeelding_2025-08-15_om_15.46.41.png)'
    }} data-id="element-2285">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60" data-id="element-2286"></div>

        <div className="relative z-10 max-w-3xl mx-auto space-y-8" data-id="element-2287">
          {/* Step 1 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2288">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2289">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2290">
                1 - Laat ons weten wat je echt wilt leren
              </h3>
            </div>
            <div className="p-6" data-id="element-2291">
              <div className="w-full h-[600px]" data-tf-live="01JM04G0YR95FE2CY2XMKEQZQ3" data-id="element-2292"></div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2293">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2294">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2295">
                2 - Controleer je email en zet de Masterclass in je Agenda
              </h3>
            </div>
            <div className="p-6 text-center space-y-4" data-id="element-2296">
              <p className="font-semibold" data-id="element-2297">
                Je ontvangt zo direct een bevestigings email met de link naar de
                Masterclass. Heb je deze niet ontvangen?
              </p>
              <p className="text-sm" data-id="element-2298">
                Check dan even je spambox of reclame folder.
              </p>
              <p className="font-bold text-lg mt-6" data-id="element-2299">
                Voor de zekerheid: zet de datum in je agenda. Klik op 'zet in de
                agenda' of voeg het handmatig toe.
              </p>
              <p className="font-bold" data-id="element-2300">Hieronder zie je hoe dat eruit ziet:</p>

              <div className="border border-gray-200 rounded p-4 bg-white mt-4 text-left text-sm" data-id="element-2301">
                <div className="flex items-center gap-2 mb-2 text-gray-500" data-id="element-2302">
                  <span className="font-bold" data-id="element-2303">Amee de Bruijn</span> via
                  webinargeek.com
                </div>
                <div className="font-bold mb-2" data-id="element-2304">
                  Aanmelding Masterclass Communiceren met je Hond
                </div>
                <div className="bg-blue-50 p-3 rounded border border-blue-100 flex items-center gap-4" data-id="element-2305">
                  <div className="bg-blue-600 text-white p-2 rounded text-center leading-tight" data-id="element-2306">
                    <div className="text-xs" data-id="element-2307">APR</div>
                    <div className="font-bold text-lg" data-id="element-2308">5</div>
                  </div>
                  <div data-id="element-2309">
                    <div className="font-bold text-blue-800" data-id="element-2310">
                      Masterclass Communiceren met je Hond
                    </div>
                    <div className="text-blue-600 text-xs" data-id="element-2311">Zet in agenda</div>
                  </div>
                </div>
              </div>

              <p className="text-sm font-semibold mt-4" data-id="element-2312">
                15 minuten voorafgaand aan de Masterclass ontvang je nogmaals
                een e-mail met de link.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2313">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2314">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2315">
                3 - Tijdens de Masterclass
              </h3>
            </div>
            <div className="p-8 text-center space-y-4 text-sm leading-relaxed" data-id="element-2316">
              <p data-id="element-2317">
                De Masterclass is live (en niet vooraf opgenomen). Dat betekent
                dat ik er echt ben en je vragen kan beantwoorden via de chat. Ik
                vind het super leuk als je actief meedoet en vragen stelt!
              </p>
              <p data-id="element-2318">
                Tijdens de Masterclass gaan we het hebben over de 3 grootste
                misverstanden die hondenbaasjes maken. We gaan het hebben over
                de taal van je hond en hoe je zelf kunt communiceren met je
                hond.
              </p>
              <p className="font-bold mt-6" data-id="element-2319">
                Zorg dat je een rustig plekje hebt om de Masterclass te volgen
                met een kopje thee of koffie en een notitieblokje.
              </p>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2320">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2321">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2322">
                4 - Volg mij op social media
              </h3>
            </div>
            <div className="p-8 text-center space-y-6 text-sm" data-id="element-2323">
              <p data-id="element-2324">
                Op social media deel ik dagelijks tips, tricks en een kijkje
                achter de schermen. Ik vind het super leuk om in contact te
                komen met andere hondenbaasjes, dus stuur me gerust een
                berichtje!
              </p>

              <div className="space-y-2" data-id="element-2325">
                <p data-id="element-2326">
                  <span className="font-bold" data-id="element-2327">Facebook:</span>{' '}
                  <a href="https://www.facebook.com/stresslessdogs.nl/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2328">
                    https://www.facebook.com/stresslessdogs.nl/
                  </a>
                </p>
                <p data-id="element-2329">
                  <span className="font-bold" data-id="element-2330">Instagram:</span>{' '}
                  <a href="https://www.instagram.com/stresslessdogs.nl/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2331">
                    https://www.instagram.com/stresslessdogs.nl/
                  </a>
                </p>
                <p data-id="element-2332">
                  <span className="font-bold" data-id="element-2333">YouTube:</span>{' '}
                  <a href="https://www.youtube.com/@stresslessdogs" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2334">
                    https://www.youtube.com/@stresslessdogs
                  </a>
                </p>
                <p data-id="element-2335">
                  <span className="font-bold" data-id="element-2336">TikTok:</span>{' '}
                  <a href="https://www.tiktok.com/@stresslessdogs.nl" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2337">
                    https://www.tiktok.com/@stresslessdogs.nl
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Step 5 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2338">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2339">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2340">
                5 - Bekijk reviews
              </h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-2341">
              <p className="text-center font-bold text-sm mb-6" data-id="element-2342">
                Hieronder kan je lezen wat andere baasjes er van vonden
              </p>

              {/* Review 1 */}
              <div className="flex gap-4" data-id="element-2343">
                <div className="w-10 h-10 bg-blue-600 text-white rounded flex items-center justify-center font-bold flex-shrink-0" data-id="element-2344">
                  V
                </div>
                <div data-id="element-2345">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2346">
                    <span className="font-bold text-sm" data-id="element-2347">Veerle</span>
                    <span className="text-xs text-gray-500" data-id="element-2348">10:33</span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-2349">
                    Bedankt voor je lezing, je hebt op een duidelijke manier en
                    met concrete voorbeelden veel inzicht bijgebracht! Iets wat
                    ik in de toekomst ook graag zou gaan doen. Veel succes nog
                    en ik volg je nog op FB.
                  </p>
                </div>
              </div>

              {/* Review 2 (Email style) */}
              <div className="border-t border-gray-200 pt-4" data-id="element-2350">
                <div className="text-xs text-gray-500 mb-2" data-id="element-2351">
                  <span className="font-bold" data-id="element-2352">Jessica</span> aan mij
                </div>
                <p className="text-sm font-bold mb-2" data-id="element-2353">Hi Amee,</p>
                <p className="text-sm text-gray-700 mb-2" data-id="element-2354">
                  Super, het is gelukt. Dankjewel!
                </p>
                <p className="text-sm text-gray-700 mb-2" data-id="element-2355">
                  Ik wilde nog mijn complimenten geven voor de masterclass van
                  gisteren. Ik heb menig gratis webinars gevolgd en vond die van
                  jou echt wel de beste. Ben benieuwd naar de cursussen!
                </p>
                <p className="text-sm text-gray-700" data-id="element-2356">Groeten, Jessica</p>
              </div>

              {/* Review 3 (Google style) */}
              <div className="border-t border-gray-200 pt-4" data-id="element-2357">
                <div className="flex items-center gap-3 mb-2" data-id="element-2358">
                  <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center font-bold text-orange-700" data-id="element-2359">
                    K
                  </div>
                  <div data-id="element-2360">
                    <div className="font-bold text-sm" data-id="element-2361">Kees van Damme</div>
                    <div className="text-xs text-gray-500" data-id="element-2362">
                      Local Guide · 122 reviews · 114 foto's
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2 mb-2" data-id="element-2363">
                  <div className="flex text-yellow-400" data-id="element-2364">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-2365" />)}
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-2366">
                    9 maanden geleden
                  </span>
                </div>
                <p className="text-sm text-gray-700" data-id="element-2367">
                  Stressless dogs geeft veel goede gedetailleerde informatie.
                  Vooral de informatie hoe je met stressvolle situaties kunt
                  omgaan zoals curven, afstand houden etc zijn erg praktisch en
                  werken goed in de praktijk. Dagelijks heb ik er plezier van en
                  mijn honden ook!
                </p>
              </div>

              {/* Review 4 */}
              <div className="border-t border-gray-200 pt-4 flex gap-4" data-id="element-2368">
                <div className="w-10 h-10 bg-green-600 text-white rounded flex items-center justify-center font-bold flex-shrink-0" data-id="element-2369">
                  B
                </div>
                <div data-id="element-2370">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2371">
                    <span className="font-bold text-sm" data-id="element-2372">Bianca</span>
                    <span className="text-xs text-gray-500" data-id="element-2373">21:31</span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-2374">
                    Bedankt voor deze Masterclass, heb er veel van opgestoken
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#111111] py-6 text-center text-xs text-gray-400" data-id="element-2375">
        <p data-id="element-2376">© 2025 Stressless Dogs. Alle rechten voorbehouden.</p>
      </footer>
    </div>;
}